import { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { Axios } from "../../../Api/axios";
import { ADMIN_ADD_CLASS } from "../../../Api/Api";
import LoadingSubmit from "../../../Components/Loading/Loading";
import { useNavigate } from "react-router-dom";
import DashDialog from "../../../Components/Dashboard/DashDialog";

export default function AddClass() {
  const [name, setName]       = useState("");
  const [loading, setLoading] = useState(false);

  const focus = useRef(null);
  const nav   = useNavigate();

  useEffect(() => { focus.current?.focus(); }, []);

  async function handleSubmit() {
    if (!name.trim()) return;
    setLoading(true);
    try {
      await Axios.post(ADMIN_ADD_CLASS, { name: name.trim() });
      nav("/dashboard/classes");
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  }

  return (
    <>
      {loading && <LoadingSubmit />}
      <DashDialog
        title="إضافة صف دراسي جديد"
        onSubmit={handleSubmit}
        submitDisabled={name.trim().length < 2 || loading}
        submitLabel={loading ? "جاري الحفظ..." : "حفظ الصف"}
      >
        <Form.Group className="mb-4" controlId="className">
          <Form.Label>اسم الصف</Form.Label>
          <Form.Control
            ref={focus}
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
            type="text"
            placeholder="مثال: الصف العاشر..."
          />
          <Form.Text className="text-muted">
            أدخل اسم الصف الدراسي كما سيظهر للطلاب
          </Form.Text>
        </Form.Group>
      </DashDialog>
    </>
  );
}
